import { useTranslation } from 'react-i18next';

import { PayButton } from '../PayButton';

interface Props {
  isLoading: boolean;
  allowSave: boolean;
  onUpdateInfo(): void;
}

export const MoretonBaySubmissionActions = ({ isLoading, allowSave, onUpdateInfo }: Props) => {
  const { t } = useTranslation();

  return (
    <PayButton
      disabled={isLoading || !allowSave}
      onClick={onUpdateInfo}
      buttonLabel={t('moreton-bay-page.submit-label')}
      terms={null}
    />
  );
};
